"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _FinProSimpleSearch = require("../FinProSimpleSearch");
var _axios = _interopRequireDefault(require("axios"));
var _generatePayload = _interopRequireDefault(require("./generatePayload"));
var _defaultSearchState = _interopRequireDefault(require("../FinProSimpleSearch/defaultSearchState"));
var _MultiplePinMap = require("../../components/finpro/maps/MultiplePinMap");
var _Popup = _interopRequireDefault(require("../CCPAForm/Common/Popup"));
var _FilterAndResults = _interopRequireDefault(require("./components/FilterAndResults"));
var _componentData = require("./componentData");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function FinProSearch(props) {
  var isMmfa = props.params.appName === "advisorcareers";
  var {
    disclaimer
  } = isMmfa ? '' : props.pageprops;
  var formData = props.formParams;
  var [searchState, setSearchState] = (0, _react.useState)({
    finProOrAgencySelection: '',
    nameOrZipCodeInputSelection: '',
    searchByName: false,
    languageOptions: [],
    specialtyOptions: [],
    specialtySelection: [],
    languageSelection: [],
    distanceFilterSelection: 'Distance: Within 5 Miles',
    distanceFilterSelectionIndex: 1,
    distanceMiles: 5,
    hasCalledForInitialData: false
  });
  var [searchTrigger, setSearchTrigger] = (0, _react.useState)(0);
  var [isFirstRender, setIsFirstRender] = (0, _react.useState)(true);
  var [shouldNotTriggerAutocomplete, setShouldNotTriggerAutocomplete] = (0, _react.useState)(true);
  var [apiData, setApiData] = (0, _react.useState)('');
  var [isLoading, setIsLoading] = (0, _react.useState)(true);
  var [initialApiDataIsSet, updateInitialApiDataIsSet] = (0, _react.useState)(false);
  var [mapData, setMapData] = (0, _react.useState)([]);
  var [hoverId, setHoverId] = (0, _react.useState)('');
  var [googleApiIsLoaded, setGoogleApiIsLoaded] = (0, _react.useState)(false);
  var [showResetFilters, setShowResetFilters] = (0, _react.useState)(false);
  var [showMapPopup, setShowMapPopup] = (0, _react.useState)(false);
  var requestIndex = (0, _react.useRef)(0);
  (0, _react.useEffect)(() => {
    // Window object is not available on first render
    if (isFirstRender) {
      setIsFirstRender(false);
      return;
    }
    // Once we have window object, we will pull data from previous page and
    if (typeof window !== 'undefined') {
      if (!(0, _lodash.isEmpty)(JSON.parse(localStorage.getItem('searchData')))) {
        var searchData = JSON.parse(localStorage.getItem('searchData'));
        localStorage.setItem('searchData', JSON.stringify({}));
        setSearchState(prevState => {
          return _objectSpread(_objectSpread(_objectSpread({}, prevState), searchData), {}, {
            initialSearchDataIsSet: true
          });
        });
      } else {
        // Use default search state if no data is found in local storage
        setSearchState(prevState => {
          var updatedSearchState = _defaultSearchState.default;
          if (isMmfa) updatedSearchState.finProOrAgencySelection = 'Agency';
          return _objectSpread(_objectSpread(_objectSpread({}, prevState), updatedSearchState), {}, {
            initialSearchDataIsSet: true
          });
        });
      }
    }
  }, [isFirstRender]);
  (0, _react.useEffect)(() => {
    // When the search state changes for the fist time as a result of pulling the local storage data
    // We want to trigger the initial API call one time by upping the count on searchTrigger
    // We also want to enable auto complete after the page has loaded

    if (searchState.finProOrAgencySelection && !searchState.hasCalledForInitialData) {
      setSearchTrigger(searchTrigger + 1);
      setSearchState(prevState => {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          hasCalledForInitialData: true
        });
      });
      setShouldNotTriggerAutocomplete(false);
    }
  }, [searchState]);
  (0, _react.useEffect)(() => {
    // If searching for blank name, we should not trigger API search call
    // Or if searching for a location which we could not find with google places api, we should not trigger API search call
    if (searchTrigger && searchState.searchByName && searchState.nameOrZipCodeInputSelection === '' || searchTrigger && !searchState.searchByName && !searchState.lat) {
      setApiData([]);
      setIsLoading(false);
      sendTealiumEvent(searchState, null);
      setSearchState(prevState => {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          languageSelection: [],
          specialtySelection: [],
          distanceMiles: 5,
          distanceFilterSelectionIndex: 1
        });
      });
      setShowResetFilters(false);
    } else if (searchTrigger) {
      var thisEffectsRequestIndex = requestIndex.current + 1;
      requestIndex.current = thisEffectsRequestIndex;
      function fetchAgentData() {
        return _fetchAgentData.apply(this, arguments);
      }
      function _fetchAgentData() {
        _fetchAgentData = _asyncToGenerator(function* () {
          try {
            setIsLoading(true);
            var agentOrAgency = searchState.finProOrAgencySelection === 'Financial Professional' ? 'agent' : 'agency';
            var result = yield _axios.default.post("/apicalls/finpro/search/".concat(agentOrAgency), (0, _generatePayload.default)(agentOrAgency, searchState, isMmfa));
            // The requestIndex is used to ensure that the data we are setting is the most recent
            // and that if multiple useEffects are queued in small amoutn of time, we only set the results of the
            // most recent one
            if (thisEffectsRequestIndex === requestIndex.current) {
              // Reset disableNextAvailableDistSearch
              // Reset upperlat and upperlng, which will only be set after someone researches from map
              setSearchState(prevState => {
                return _objectSpread(_objectSpread({}, prevState), {}, {
                  disableNextAvailableDistSearch: false,
                  upperlat: '',
                  upperlng: '',
                  isRedoSearch: false,
                  hideDistanceFilter: searchState.isRedoSearch
                });
              });
              setApiData(result);
              sendTealiumEvent(searchState, result);
              setIsLoading(false);
            }
          } catch (err) {
            // stop loading and show error
            setIsLoading(false);
            console.error(err);
          }
        });
        return _fetchAgentData.apply(this, arguments);
      }
      fetchAgentData();
      // Determine if a search was made with filters, if so update state so we can track this and render reset button
      var filtersAreApplied = !!(searchState.languageSelection.length > 0 || searchState.specialtySelection.length > 0);
      setShowResetFilters(filtersAreApplied);
      // save previous filter selections to searchState
      setSearchState(prevState => {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          lastFiltersUsed: {
            languageSelection: prevState.languageSelection,
            specialtySelection: prevState.specialtySelection
          }
        });
      });
    }
  }, [searchTrigger]);
  (0, _react.useEffect)(() => {
    var _apiData$data;
    // Need to filter out no longer existing langauges and specialies that were previously selected in filters
    // but don't exist in new search results
    if (apiData !== null && apiData !== void 0 && (_apiData$data = apiData.data) !== null && _apiData$data !== void 0 && (_apiData$data = _apiData$data.data) !== null && _apiData$data !== void 0 && _apiData$data.hits) {
      var _apiData$data4, _apiData$data5;
      if (searchState.languageSelection) {
        var newLanguageSelection = [];
        // iterate through previous langauge selections
        searchState.languageSelection.forEach(languageObject => {
          var _apiData$data2;
          // if language still exists in results, push to newLanguageSelections
          if (apiData !== null && apiData !== void 0 && (_apiData$data2 = apiData.data) !== null && _apiData$data2 !== void 0 && (_apiData$data2 = _apiData$data2.data) !== null && _apiData$data2 !== void 0 && _apiData$data2.languagefacet.some(e => e.key === languageObject.label)) {
            newLanguageSelection.push(languageObject);
          }
          setSearchState(prevValue => {
            return _objectSpread(_objectSpread({}, prevValue), {}, {
              languageSelection: newLanguageSelection
            });
          });
        });
      }
      if (searchState.specialtySelection) {
        var newspecialtySelection = [];
        // iterate through previous specialty selections
        searchState.specialtySelection.forEach(specialtyObject => {
          var _apiData$data3;
          // if specialty still exists in results, push to newSpecialtySelections
          if (apiData !== null && apiData !== void 0 && (_apiData$data3 = apiData.data) !== null && _apiData$data3 !== void 0 && (_apiData$data3 = _apiData$data3.data) !== null && _apiData$data3 !== void 0 && _apiData$data3.specialtyfacet.some(e => e.key === specialtyObject.label)) {
            newspecialtySelection.push(specialtyObject);
          }
          setSearchState(prevValue => {
            return _objectSpread(_objectSpread({}, prevValue), {}, {
              specialtySelection: newspecialtySelection
            });
          });
        });
      }
      // If results returned a distanceFacet that does not match our current distanceMiles
      // we should update our distanceMiles and distanceFilterSelectionIndex with the new values
      if (apiData !== null && apiData !== void 0 && (_apiData$data4 = apiData.data) !== null && _apiData$data4 !== void 0 && (_apiData$data4 = _apiData$data4.data) !== null && _apiData$data4 !== void 0 && _apiData$data4.distkeyselected && (apiData === null || apiData === void 0 || (_apiData$data5 = apiData.data) === null || _apiData$data5 === void 0 || (_apiData$data5 = _apiData$data5.data) === null || _apiData$data5 === void 0 ? void 0 : _apiData$data5.distkeyselected) !== "d".concat(searchState.distanceMiles)) {
        var _apiData$data6;
        var newDistanceMiles = apiData === null || apiData === void 0 || (_apiData$data6 = apiData.data) === null || _apiData$data6 === void 0 || (_apiData$data6 = _apiData$data6.data) === null || _apiData$data6 === void 0 ? void 0 : _apiData$data6.distkeyselected.replace('d', '');
        var newDistanceFilterSelectionIndex = Object.keys(_componentData.DISTANCEKEY).find(key => _componentData.DISTANCEKEY[key] === parseInt(newDistanceMiles));
        setSearchState(prevValue => {
          return _objectSpread(_objectSpread({}, prevValue), {}, {
            distanceMiles: newDistanceMiles,
            distanceFilterSelectionIndex: newDistanceFilterSelectionIndex
          });
        });
      }
      // Everytime we get new search results we want to format the data for the map
      if (searchState.finProOrAgencySelection === 'Financial Professional') {
        var _apiData$data7;
        var newMapData = [];
        var agencyTempKey = {};
        // Construct an object with unique agency ids as keys and the agency data as values
        // This will let us count the number of agents per agency
        apiData === null || apiData === void 0 || (_apiData$data7 = apiData.data) === null || _apiData$data7 === void 0 || (_apiData$data7 = _apiData$data7.data) === null || _apiData$data7 === void 0 || _apiData$data7.hits.forEach(agent => {
          var uniqueId = agent.agency.coreagencynumber;
          if (agent.agency.subagencynumber) uniqueId += '-' + agent.agency.subagencynumber;
          if (!agencyTempKey[uniqueId]) {
            agencyTempKey[uniqueId] = {
              count: 1,
              agencyName: agent.agency.agencyname,
              agencyUrl: agent.agency.agencyurl,
              officeType: agent.agency.officetype,
              coreagencynumber: agent.agency.coreagencynumber,
              subagencynumber: agent.agency.subagencynumber,
              location: {
                addressLine: agent.agency.location.addressline,
                addressLinesExtra: agent.agency.location.addresslinesextra,
                city: agent.agency.location.city,
                latitude: agent.agency.location.latitude,
                longitude: agent.agency.location.longitude,
                phone: agent.agency.location.phone,
                state: agent.agency.location.state,
                zip: agent.agency.location.zip
              }
            };
          } else {
            agencyTempKey[uniqueId].count++;
          }
        });
        // Construct an array of agencies from the object we just created
        for (var [key, value] of Object.entries(agencyTempKey)) {
          newMapData.push(_objectSpread({}, value));
        }
        // Construct agency key based on array we just created, this will let use identify the index of an agency by its unique id
        // This will be used in setHoverId for agent scenario
        var agencyKey = {};
        newMapData.forEach((agency, index) => {
          var uniqueId = agency.coreagencynumber;
          if (agency.subagencynumber) uniqueId += '-' + agency.subagencynumber;
          agencyKey[uniqueId] = index;
        });
        setMapData({
          agencyData: newMapData,
          agencyKey
        });
      } else {
        var _apiData$data8;
        var agencyFormattedData = apiData === null || apiData === void 0 || (_apiData$data8 = apiData.data) === null || _apiData$data8 === void 0 || (_apiData$data8 = _apiData$data8.data) === null || _apiData$data8 === void 0 ? void 0 : _apiData$data8.hits.map(agency => {
          return {
            agencyName: agency.agencyname,
            agencyUrl: agency.agencyurl,
            location: {
              addressLine: agency.location.addressline,
              addressLinesExtra: agency.location.addresslinesextra,
              city: agency.location.city,
              latitude: agency.location.latitude,
              longitude: agency.location.longitude,
              phone: agency.location.phone,
              state: agency.location.state,
              zip: agency.location.zip
            }
          };
        });
        setMapData({
          agencyData: agencyFormattedData,
          agencyKey: {}
        });
      }
    } else {
      setMapData({
        agencyData: [],
        agencyKey: {}
      });
    }
    if (searchTrigger && !initialApiDataIsSet) {
      updateInitialApiDataIsSet(true);
    }
  }, [apiData]);
  function _onSearch() {
    setSearchTrigger(searchTrigger + 1);
  }
  function redoSearchOnClick(bounds) {
    setSearchState(prevState => {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        upperlat: bounds.north,
        upperlng: bounds.east,
        lat: bounds.south,
        lng: bounds.west,
        isRedoSearch: true
      });
    });
    _onSearch();
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "app-container",
    role: "main"
  }, searchState.initialSearchDataIsSet && searchState.languageOptions ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_FinProSimpleSearch.FinProSimpleSearchCard, {
    onSearch: optionalSearchTerm => _onSearch(optionalSearchTerm),
    className: "mm-desktop-only",
    searchState: searchState,
    setSearchState: setSearchState,
    setApiData: setApiData,
    setIsLoading: setIsLoading,
    shouldNotTriggerAutocomplete: shouldNotTriggerAutocomplete,
    setGoogleApiIsLoaded: setGoogleApiIsLoaded,
    isMmfa: isMmfa
  }), /*#__PURE__*/_react.default.createElement(_FinProSimpleSearch.FinProSimpleSearchCard, {
    onSearch: optionalSearchTerm => _onSearch(optionalSearchTerm),
    className: "mm-tablet-mobile-only",
    searchState: searchState,
    setSearchState: setSearchState,
    setApiData: setApiData,
    setIsLoading: setIsLoading,
    shouldNotTriggerAutocomplete: shouldNotTriggerAutocomplete,
    setGoogleApiIsLoaded: setGoogleApiIsLoaded,
    isMmfa: isMmfa
  })) : undefined, /*#__PURE__*/_react.default.createElement(_FilterAndResults.default, {
    searchState: searchState,
    setSearchState: setSearchState,
    apiData: apiData,
    isLoading: isLoading,
    onSearch: _onSearch,
    mapData: mapData,
    hoverId: hoverId,
    setHoverId: setHoverId,
    disclaimer: disclaimer,
    formData: formData,
    googleApiIsLoaded: googleApiIsLoaded,
    initialApiDataIsSet: initialApiDataIsSet,
    showResetFilters: showResetFilters,
    setShowMapPopup: setShowMapPopup,
    redoSearchOnClick: redoSearchOnClick,
    isMmfa: isMmfa
  }), /*#__PURE__*/_react.default.createElement(_Popup.default, {
    show: showMapPopup,
    handleClose: () => setShowMapPopup(false),
    title: "Map",
    content: /*#__PURE__*/_react.default.createElement("div", {
      className: "map-col popup-map-col"
    }, /*#__PURE__*/_react.default.createElement(_MultiplePinMap.MultiplePinMap, {
      agencyList: mapData.agencyData,
      hoverId: hoverId,
      setHoverId: setHoverId,
      redoSearchOnClick: redoSearchOnClick
    }))
  }));
}
function sendTealiumEvent(searchState, results) {
  var maxWaitTime = 5000; // Maximum wait time in milliseconds
  var checkInterval = 100; // Interval to check for utag availability in milliseconds

  var _waitForUtag = function waitForUtag(resolve, reject) {
    var elapsedTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    if (window.utag) {
      resolve();
    } else if (elapsedTime >= maxWaitTime) {
      reject(new Error('utag object not available within the maximum wait time'));
    } else {
      setTimeout(() => {
        _waitForUtag(resolve, reject, elapsedTime + checkInterval);
      }, checkInterval);
    }
  };
  return new Promise((resolve, reject) => {
    _waitForUtag(resolve, reject);
  }).then(() => {
    // utag is available, proceed with the function
    // eslint-disable-next-line no-undef
    if (typeof utag === 'object' && utag.link) {
      var _results$data, _results$data2;
      // create object with filters if appicable, spread them into the link function below
      var filters = '';
      if (searchState.languageSelection.length > 0) {
        searchState.languageSelection.map((language, index) => {
          if (index === 0) {
            filters += "lang:".concat(language.label);
          } else {
            filters += '#' + language.label;
          }
        });
      }
      if (searchState.specialtySelection.length > 0) {
        // add comma if there were previous filters added
        if (filters) filters += ',';
        searchState.specialtySelection.map((specialty, index) => {
          if (index === 0) {
            filters += "focus:".concat(specialty.label);
          } else {
            filters += '#' + specialty.label;
          }
        });
      }
      if (searchState.distanceMiles !== 5) {
        // add comma if there were previous filters added
        if (filters) filters += ',';
        filters += "Distance: ".concat(searchState.distanceMiles);
      }
      // create final data object for link function, spread in filters if applicable
      var utagDataObject = {
        site_id: 'MM-Advisor',
        search_term: searchState.nameOrZipCodeInputSelection,
        search_type: searchState.searchByName ? 'name' : 'location',
        scope: searchState.finProOrAgencySelection === 'Financial Professional' ? 'advisor' : 'agency',
        results_count: results !== null && results !== void 0 && (_results$data = results.data) !== null && _results$data !== void 0 && (_results$data = _results$data.data) !== null && _results$data !== void 0 && _results$data.totalitems ? results === null || results === void 0 || (_results$data2 = results.data) === null || _results$data2 === void 0 || (_results$data2 = _results$data2.data) === null || _results$data2 === void 0 ? void 0 : _results$data2.totalitems.toString() : '0'
      };
      if (filters) {
        utagDataObject.filters = filters;
      }
      // eslint-disable-next-line no-undef
      utag.view(utagDataObject);
    }
  }).catch(error => {
    // Handle the error or fallback logic here
    console.error(error);
    console.error('Utag object not available within the maximum wait time');
  });
}
var _default = exports.default = FinProSearch;